module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Идентификатор пользователя")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.id),
      expression: "profile.id"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": (_vm.profile.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.roleId),
      expression: "profile.roleId"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Администратор")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Партнер")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Реферер")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Клиент")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.state),
      expression: "profile.state"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FILL_PROFILE"
    }
  }, [_vm._v("Заполните личную карточку")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SIGN_CONTRACT"
    }
  }, [_vm._v("Ожидаем подписания договора")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "REFILL_BALANCE"
    }
  }, [_vm._v("Нужно пополнить баланс")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("Активен")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ФИО")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.fullname),
      expression: "profile.fullname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "fullname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Часовой пояс (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.timeZone),
      expression: "profile.timeZone"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "timeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.phone),
      expression: "profile.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ИНН")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.INN),
      expression: "profile.INN"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.INN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "INN", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Паспорт")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.passport),
      expression: "profile.passport"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "passport", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вид деятельности")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.businessType),
      expression: "profile.businessType"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.businessType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "businessType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Менеджер")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.manager),
      expression: "profile.manager"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.manager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "manager", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тариф")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.tariff),
      expression: "profile.tariff"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.tariff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "tariff", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "id": "uploadFile",
      "value": "Загрузить скан договора (pdf, jpg, png; до 10 Мб)",
      "onclick": "document.getElementById('uploadContract').click();"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadContract",
      "name": "load-contract",
      "type": "file",
      "accept": ".jpg,.png,.pdf"
    },
    on: {
      "input": function($event) {
        return _vm.uploadContract('uploadContract')
      }
    }
  }), _vm._v(" "), (_vm.profile.contractName != '') ? _c('a', {
    attrs: {
      "href": '/api/profiles/contract?userId=' + this.$props.id,
      "tag": "button"
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('span', [_vm._v("Просмотр договора")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a58c152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/profiles/Profile.vue
// module id = 442
// module chunks = 40